
<div class="cadre-annonce w-100" :class="jel_getClassObject(content)">
  <div class="annonce bg-annonce">
    <div class="casino">
      <b-img-lazy
        :src="jel_getFichierSrc(content.image)"
        :alt="content.altImage"
        class="pr-1 logo-progressif"
      />
    </div>
    <div v-if="isProgressifActif && mntProgressif" cols="9" class="amount">
      <div
        class="overflow-hidden graphik_semibold d-flex align-items-start justify-content-center montant w-100"
        :class="`montant-${$i18n.locale}`"
      >
        <div v-if="$i18n.locale == 'en'" class="dollarsign">$</div>
        <div
          v-for="(chiffre, index) in arrMntProgressif"
          :key="index"
          class="align-items-center"
          :class="
            chiffre == ' ' || isNaN(chiffre)
              ? 'lot-valeur-num-espace'
              : 'container-chiffre lot-valeur-num'
          "
        >
          <span
            :class="[
              chiffre == ' ' || isNaN(chiffre)
                ? 'separateur'
                : 'case-chiffre chiffre d-flex align-items-center justify-content-center',
            ]"
          >
            {{ chiffre.replace(' ', '&nbsp;') }}
          </span>
        </div>
        <span v-if="$i18n.locale == 'fr'" class="dollarsign">$</span>
        <span class="approx" :class="$i18n.locale == 'en' ? 'en' : ''">{{
          $i18n.tc('messageComponent.approx')
        }}</span>
      </div>
    </div>
    <div v-else cols="9">
      <div class="error">{{ $i18n.tc('messageComponent.error') }}</div>
    </div>
    <div class="boutons w-100">
      <b-link v-bind="jel_getLienBinding(content.lien)" class="jouer"
        >{{ $i18n.tc('messageComponent.jouer') }}
      </b-link>
    </div>
  </div>
</div>
